var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgActionDownloadPdf = function SvgActionDownloadPdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9092",
    "data-name": "Group 9092",
    transform: "translate(-1285 -185)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M-1601.236-6913.119A2.824,2.824,0,0,1-1603.9-6915h-1.1v-7.528h.941v-5.646a2.823,2.823,0,0,1,2.824-2.824h4.7l6.587,6.587v1.883h.943V-6915h-1.1a2.823,2.823,0,0,1-2.662,1.883Zm0-.942h8.47a1.882,1.882,0,0,0,1.631-.941h-11.731A1.882,1.882,0,0,0-1601.236-6914.061Zm7.476-1.882h1.038v-2.032h1.838v-.994h-1.838v-1.25h1.838v-.994h-2.876Zm-5.369,0h2.094a2.411,2.411,0,0,0,1.807-.76,2.6,2.6,0,0,0,.73-1.875,2.6,2.6,0,0,0-.73-1.876,2.41,2.41,0,0,0-1.807-.76h-2.094Zm-3.4,0v-1.732h.927a1.766,1.766,0,0,0,1.28-.511,1.7,1.7,0,0,0,.519-1.257,1.69,1.69,0,0,0-.519-1.257,1.764,1.764,0,0,0-1.28-.513h-1.964v5.27h1.038Zm11.649-6.587v-.941h-3.765a2.823,2.823,0,0,1-2.824-2.822v-3.765h-3.763a1.883,1.883,0,0,0-1.882,1.883v5.646Zm-5.648-3.764a1.881,1.881,0,0,0,1.883,1.881h3.374l-5.256-5.256Zm-1.558,9.357v-3.282h1.054a1.446,1.446,0,0,1,1.115.458,1.639,1.639,0,0,1,.429,1.184,1.66,1.66,0,0,1-.429,1.188,1.456,1.456,0,0,1-1.115.452Zm-4.443-1.707v-1.6h.927a.757.757,0,0,1,.768.8.766.766,0,0,1-.768.8Z",
    transform: "translate(2894.999 7120)",
    fill: "#008060"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3945",
    "data-name": "Rectangle 3945",
    width: 24,
    height: 24,
    transform: "translate(1283 183)",
    fill: "none"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActionDownloadPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/action-download-pdf.e855affb.svg";
export { ForwardRef as ReactComponent };